export const convertSuToHierarchyString = (input: string) => {
  // Определяем порядок иерархии
  const hierarchy = [
    'Раздел',
    'Подраздел',
    'Глава',
    'Параграф',
    'Статья',
    'Часть',
    'Пункт',
    'Подпункт',
    'Абзац',
    'Другое / прочее',
  ];

  // Создаем объект для хранения значений
  const elements: { [key: string]: string } = {};

  // Разбиваем строку на компоненты
  const parts = input.split(', ');

  // Заполняем объект значениями
  parts.forEach(part => {
    if (part.startsWith('Другое / прочее')) {
      // Обрабатываем "Другое / прочее" отдельно
      const value = part.split(' ');

      elements['Другое / прочее'] = value[value.length - 1];
    } else {
      // Разделяем по первому пробелу
      const spaceIndex = part.indexOf(' ');
      const key = part.slice(0, spaceIndex);

      elements[key] = part.slice(spaceIndex + 1);
    }
  });

  // Собираем итоговую строку в правильном порядке
  return hierarchy
    .filter(key => {
      return elements[key] !== undefined;
    })
    .map(key => `${key}: ${elements[key]}`)
    .join('\\');
};
